export default __webpack_public_path__ + "static/media/measure.11e16f94.svg";